module.exports = __webpack_public_path__ + "static/media/diretora-financeira.0b52c5a2.png";